import { createFileRoute, useSearch } from "@tanstack/react-router";
import Left from "@repo/icons/default/Left";
import { z } from "zod";
import {
  HeaderButton,
  HeaderRoot,
  HeaderTitle,
} from "@/components/ui/layout/header/header";
import { Page } from "@/components/ui/layout/page/page";
import { RecommendationMembersForPatientSearch } from "@/components/recommendation/recommendation-members-for-patient-search";
import { RecommendationPatientsForMemberSearch } from "@/components/recommendation/recommendation-patients-for-member-search";

import type { JSX } from "react";

const searchSchema = z.object({
  patientId: z.number().optional(),
  userId: z.number().optional(),
});

const RecommendationMembersForPatientPage = (): JSX.Element => {
  const params = useSearch({ from: "/recommendation/" });

  const isMembersForPatientRecommendation = Boolean(params.patientId);
  const title = isMembersForPatientRecommendation
    ? "Indicação de profissional"
    : "Indicação de paciente";

  return (
    <>
      <HeaderRoot>
        <HeaderButton icon={Left} align="start" />
        <HeaderTitle title={title} align="center" />
      </HeaderRoot>
      <Page>
        {isMembersForPatientRecommendation ? (
          <RecommendationMembersForPatientSearch />
        ) : null}
        {!isMembersForPatientRecommendation ? (
          <RecommendationPatientsForMemberSearch />
        ) : null}
      </Page>
    </>
  );
};
export const Route = createFileRoute("/recommendation/")({
  component: RecommendationMembersForPatientPage,
  validateSearch: searchSchema,
});
